import ko from 'knockout';
import templateMarkup from 'raw-loader!./flexomniquery-widget.html';
import UtilsService from '../../../services/utils.service';
import _ from 'lodash';
import '../../../app/bindings/ko-bindinghandler-tokenfield';
import './ko-custombinding-jstree';
import UtilService from '../../../services/utils.service';
import Vue from 'vue';
import vuetify from '../../../plugins/vuetify';
import FilterExpression from '../../../vueComponents/filterExpression/src/filterExpression.vue';
import MetadataService from "../../../services/metadata.service";
import DataService from "../../../modules/assurance/services/data.service";

const MODEL_COLUMN = 'dimendpoint.model';
const SYSTEM_COLUMN = 'dimsystem.systemname';
const OPERATOR_DISPLAY_TEXT_MAP = {
    'in': 'in',
    'notin': 'not in',
    '=': 'equals',
    '!=': 'does not equal',
    '>': 'is greater than',
    '>=': 'is greater than or equal to',
    '<': 'is less than',
    '<=': 'is less than or equal to',
    like: 'contains',
};

const FILTER_OPERATOR_MAP = {
  'string': {
    'in': 'in',
    'not in': 'notin',
    'equals': '=',
    'does not equal': '!=',
    'contains': 'like',
    'does not contain': 'notlike',
    'starts with': 'startswith',
    'ends with': 'endswith'
  },
  'uuid': {
    'equals': '=',
    'does not equal': '!='
  },
  'number': {
    'equals': '=',
    'does not equal': '!=',
    'is less than': '<',
    'is less than or equal to': '<=',
    'is greater than': '>',
    'is greater than or equal to': '>=',
    'less than': '<',
    'less than or equal to': '<=',
    'greater than': '>',
    'greater than or equal to': '>=',
  },
  // 'datetime': {
  //   'is prior to': '<',
  //   'is on or prior to': '<=',
  //   'is after': '>',
  //   'is on or after': '>='
  // },
  'list': {
    'in': 'in',
    'not in': 'notin'
  }
};

const REVERSE_FILTER_OPERATOR_MAP = {
  'string': _.invert(FILTER_OPERATOR_MAP['string']),
  'uuid': _.invert(FILTER_OPERATOR_MAP['uuid']),
  'number': _.invert(FILTER_OPERATOR_MAP['number']),
  'list'  : _.invert(FILTER_OPERATOR_MAP['list'])
};

function getOperatorDisplayText(operator) {
    var displayText = OPERATOR_DISPLAY_TEXT_MAP[operator];
    if (_.isUndefined(displayText)) {
        console.error('flexomniquery-widget::getOperatorDisplayText: Could not find operator "' + operator + '"');
        return '??';
    }
    return displayText;
}

function flexomniqueryWidget(params) {
    var self = this;

    self.id = UtilsService.generateID();
    self.params = params;
    self.observableOptions = params.observableOptions;
    self.columnOptionsObs = params.columnOptionsObs;
    self.returnExpressionObs = ko.observable();
    self.visibilityOptions = params.visibilityOptions;
    self.vueFilterID = 'vueFilterExpression-' + UtilService.generateID();
    self.filters = [];
    self.filterExpressionOperator = 'and';
    self.filterExpressionGroups = [{ filters: [], operator: 'and' }];

    self.subscriptions = [];

    self.typeaheadDisplayMode = params.typeaheadDisplayMode || 'typeahead-full';

    var columnOptions = ko.pureComputed(function () {
        if (self.columnOptionsObs) {
          return self.columnOptionsObs();
        }
        return  params.observableOptions().columnOptions;
    });

    self.endpointModels = params.endpointModels;
    self.systems = params.systems;

    self.selectedEndpointModels = ko.observableArray([]);
    self.selectedSystems = ko.observableArray([]);

    self.modelsSearchString = ko.observable();
    self.systemsSearchString = ko.observable();

    self.endpointModelsTreeVisible = ko.pureComputed(function () {
        var visibilityOptions = ko.unwrap(self.visibilityOptions);
        let hasModelsColumn = false;
        let columns = ko.unwrap(columnOptions);

        if (_.has(visibilityOptions, 'hideModels') && visibilityOptions.hideModels) {
            return false;
        }
        columns.forEach(function(column) {
            if (column.name === MODEL_COLUMN) {
                hasModelsColumn = true;
            }
        });
        if (hasModelsColumn) {
            return !_.isEmpty(ko.unwrap(self.endpointModels));
        }
        return false;
    }, self);

    self.systemsTreeVisible = ko.pureComputed(function () {
        var visibilityOptions = ko.unwrap(self.visibilityOptions);
        let hasSystemColumn = false;
        let columns = ko.unwrap(columnOptions);

        if (_.has(visibilityOptions, 'hideSystems') && visibilityOptions.hideSystems) {
            // short circuit if hidden
            return false;
        }
        columns.forEach(function(column) {
            if (column.name === SYSTEM_COLUMN) {
                hasSystemColumn = true;
            }
        });
        if (hasSystemColumn) {
            return !_.isEmpty(ko.unwrap(self.systems));
        }
        return false;
    }, self);

    self.displayFilterLabel = ko.pureComputed(function() {
        return self.typeaheadDisplayMode === 'typeahead-compact' && (self.systemsTreeVisible() || self.endpointModelsTreeVisible());
    });

    self.setTreeColumnTokens = function (newvals, columnName, columnTitle) {
        if (self.loadMode) {
            return;
        }
        let filterGroups = self.filterExpressionGroups;

        if (newvals.length) {

            // find the position on the existing tree column filter, if one exists
            let hasExistingFilter = false;
            let filterGroupPos;
            let filterPos;
            for (let i=0; i<filterGroups.length; i++) {
              let filters = filterGroups[i].filters;
              for (let j=0, _j=filters.length; j<_j; j++) {
                if (filters[j].field === columnName && filters[j].type === 'list') {
                  filterGroupPos = i;
                  filterPos = j;
                  hasExistingFilter = true;
                  break;
                }
              }
              if (hasExistingFilter) {
                break;
              }
            }

            let decodedVals = [...newvals].map(val => {
              return _.unescape(val);
            });

            let listFilter = {
              field: columnName,
              filterComplete: true,
              text: `${columnTitle} in ( ${decodedVals.join(', ')} )`,
              value: columnName + '=in=(\"' + decodedVals.join(',') + '\")', // todo what should this be
              queryVar: decodedVals.join(','), // todo support passing array vs string
              type: 'list',
              operator: 'in'
            };

            if (hasExistingFilter) {
              // NOTE: It is necessary to use Array.splice here, otherwise Vue will not detect the change and the filter expression component will not update
              filterGroups[filterGroupPos].filters.splice(filterPos, 1, listFilter);
            } else {
              // if the right-most filter group has no filters applied, add the list filter to it, otherwise create a new filter group
              if (filterGroups.length && !filterGroups[filterGroups.length - 1].filters[0].value) {
                filterGroups[filterGroups.length - 1].filters[0] = listFilter;
              } else {
                filterGroups.push({
                  filters: [listFilter],
                  operator: 'and'
                });
              }
            }
        } else {
            //  unselected all, remove filter
            for (let i=0, _i=filterGroups.length; i<_i; i++) {
              let filters = filterGroups[i].filters;
              for (let j=0, _j=filters.length; j<_j; j++) {
                if (filters[j].field === columnName && filters[j].type === 'list') {
                  filters.splice(j, 1);
                }
              }
            }
        }

        self.filterExpressionGroups = filterGroups;
        if (self.vueFilter) {
          self.vueFilter.filterGroups = [...filterGroups];
        }
        let filters = translateFilterExpressionToConditions(filterGroups);
        self.acceptedTokens(filters);
    };

    self.preventTreeClose = function(el, event) {
         event.stopPropagation();
    };

    self.selectedEndpointModels.subscribe(function (newvals) {
        self.setTreeColumnTokens(newvals, MODEL_COLUMN, "Endpoint Model");
    });

    self.selectedSystems.subscribe(function (newvals) {
        self.setTreeColumnTokens(newvals, SYSTEM_COLUMN, "System Name");
    });

    self.acceptedTokens = ko.observableArray();
    self.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;
    self.validationMessage = ko.observable(false);
    self.widgetSignals = params.widgetSignals;

    if (isObservableDataLoaded(params.observableData) && self.widgetSignals && self.widgetSignals.dataLoaded) {
        // trigger dataLoaded if the data was loaded prior to the widget being constructed
        self.widgetSignals.dataLoaded.dispatch();
    }

    DataService.fetchAddCpmaDatasetMetadata().then((addCpmaMetadata) => {

      if (params.viewLevelOptions) {
        self.subscriptions.push(params.viewLevelOptions.subscribe(function () {
          if (self.loadMode) {
            return;
          }

          loadSavedCondition();
        }));
      }

      // we should be able to assume this subscription will always return a new filter condition rather than the legacy format conditions
      self.subscriptions.push(self.acceptedTokens.subscribe(function (tokensVal) {
        if (self.loadMode) {
          return;
        }

        var groups = !_.isEmpty(tokensVal) ? tokensVal : [];

        self.loadMode = true;

        let endpointModels = [];
        let systems = [];
        groups.forEach(token => {
          token.conditions.forEach(condition => {
            // we assume there is at most 1 of each of these list conditions in the filter expression
            if (condition.selectedLhs === MODEL_COLUMN) {
              endpointModels = condition.selectedRhs;
            }
            if (condition.selectedLhs === SYSTEM_COLUMN) {
              systems = condition.selectedRhs;
            }
          });
        });

        self.selectedEndpointModels(endpointModels);
        self.selectedSystems(systems);

        params.viewLevelOptions({
          WhereConditionObj: groups,
          WhereConditionConjunction: self.filterExpressionOperator.toUpperCase()
        });

        self.loadMode = false;
      }));

      function loadSavedCondition() {
        var vlo = params.viewLevelOptions();
        var savedConditions = [];

        if (!_.isEmpty(vlo) && vlo.WhereConditionObj) {
          if (vlo.WhereConditionObj.WhereConditionObj) {
            savedConditions = vlo.WhereConditionObj.WhereConditionObj;
          } else {
            savedConditions = vlo.WhereConditionObj;
          }

          var selectedEndpointModels = [];
          var selectedSystems = [];

          savedConditions.forEach(function (savedCondition) {
            if (savedCondition.conditions) {
              savedCondition.conditions.forEach(cond => {
                if (!_.isEmpty(ko.unwrap(columnOptions))) {
                  FixCondition(cond, ko.unwrap(columnOptions));
                }
                if (cond.selectedLhs === MODEL_COLUMN) {
                  selectedEndpointModels = cond.selectedRhs;
                }
                if (cond.selectedLhs === SYSTEM_COLUMN) {
                  selectedSystems = cond.selectedRhs;
                }
              });
            } else {
              if (_.isEmpty(savedCondition.desc) || _.startsWith(savedCondition.desc, 'dim')) {
                if (!_.isEmpty(ko.unwrap(columnOptions))) {
                  FixCondition(savedCondition, ko.unwrap(columnOptions));
                }
                if (
                  !_.startsWith(savedCondition.selectedLhsTitle, 'dim') &&
                  !_.isEmpty(savedCondition.selectedLhsTitle) &&
                  !_.isEmpty(savedCondition.selectedOperator) &&
                  !_.isEmpty(savedCondition.rhsText)) {
                  savedCondition.desc = savedCondition.selectedLhsTitle + " " + savedCondition.selectedOperatorTitle + " " + savedCondition.rhsText;
                }
              }

              if (savedCondition.selectedLhs === MODEL_COLUMN) {
                selectedEndpointModels = savedCondition.selectedRhs;
              }
              if (savedCondition.selectedLhs === SYSTEM_COLUMN) {
                selectedSystems = savedCondition.selectedRhs;
              }
            }
          });

          self.loadMode = true;
          self.selectedEndpointModels(selectedEndpointModels);
          self.selectedSystems(selectedSystems);
          translateConditionsToFilterExpression(savedConditions);
          self.acceptedTokens(translateFilterExpressionToConditions(self.filterExpressionGroups));
          self.loadMode = false;
          self.acceptedTokens.valueHasMutated();
        } else {
          self.filterExpressionGroups = [{filters: [], operator: 'and'}];
        }
      }

      function FixCondition(condition, columnOptions) {
        var lhs = columnOptions.filter(function (co) {
          return co.name === condition.selectedLhs;
        });
        var conditionValue;

        condition.selectedLhsTitle = condition.selectedLhsTitle || (condition.lhstitle ? condition.lhstitle : condition.selectedLhs);

        if (lhs.length > 0) {
          condition.selectedLhsTitle = lhs[0].title;
        }
        if (condition.selectedOperator === 'in' || condition.selectedOperator === 'notin') {
          condition.selectedOperatorTitle = condition.selectedOperator === 'in' ? 'in' : 'not in';
          conditionValue = _.isArray(condition.selectedRhs) ? condition.selectedRhs.join(', ') : condition.selectedRhs;
          condition.listtype = true;
        } else {
          conditionValue = condition.rhsText;
          condition.listtype = false;
          condition.selectedRhs = [];
        }
        if (!condition.conjunctionVisible) {
          condition.conjunctionVisible = false;
        }
        if (!condition.hidden) {
          condition.hidden = false;
        }
        if (condition.optitle) {
          condition.selectedOperatorTitle = condition.optitle;
        } else if (condition.selectedOperator) {
          condition.selectedOperatorTitle = getOperatorDisplayText(condition.selectedOperator);
        }
        condition.desc = condition.selectedLhsTitle + " " + condition.selectedOperatorTitle + " " + conditionValue;
      }

      function translateConditionsToFilterExpression(conditions) {
        let vlo = params.viewLevelOptions();
        let operator = (vlo && vlo.WhereConditionConjunction) ? vlo.WhereConditionConjunction.toLowerCase() : 'and';
        let filterGroups = [];
        if (conditions && conditions.length) {
          conditions.forEach(condition => {
            // confusingly, each "condition" in the new filter format has a "conditions" array as one of its parameters
            if (condition.conditions) { // new filter format
              if (!condition.selectedConjunction) {
                condition.selectedConjunction = 'AND';
              }
              let filterGroup = {
                operator: condition.selectedConjunction.toLowerCase(),
                filters: []
              };
              condition.conditions.forEach(cond => {
                filterGroup.filters.push(getFilterFromCondition(cond, addCpmaMetadata));
              });
              filterGroups.push(filterGroup);
            } else { // legacy filter format
              if (!filterGroups.length) {
                filterGroups.push({
                  operator: 'and',
                  filters: []
                })
              }
              filterGroups[0].filters.push(getFilterFromCondition(condition, addCpmaMetadata));
            }
          });
        } else {
          filterGroups = [{filters: [], operator: 'and'}]; // default filterGroups value
        }
        // This is an example of a filterGroups array. Filters require a 'value' prop or the component won't render them properly.
        // let filterGroups = [
        //   {
        //     operator: 'and',
        //     filters: [{
        //       text: "Age is greater than 18",
        //       value: "18",
        //       etc . . .
        //     }]
        //   }
        // ];
        self.filterExpressionOperator = operator;
        self.filterExpressionGroups = filterGroups;
        if (self.vueFilter) {
          self.vueFilter.filterGroups = filterGroups;
          self.vueFilter.operator = operator;
        }
      }

      self.subscriptions.push(self.columnOptionsObs.subscribe(function (columns) {
        if (self.vueFilter) {
          self.vueFilter.columns = convertColumns(columns);
        }
        if (self.loadMode) {
          return;
        }
        loadSavedCondition();
      }));

      loadSavedCondition();

    });

}

flexomniqueryWidget.prototype.koDescendantsComplete = function() {
    let self = this;
    const elementId = '#' + self.vueFilterID;
    let element = document.getElementById(self.vueFilterID);
    // setup Vue filter component
    if (!self.vueFilter && element) {
      self.vueFilter = new Vue({
        el: elementId,
        data: function() {
          return {
            columns: [],
            operator: self.filterExpressionOperator,
            filterGroups: self.filterExpressionGroups
          };
        },
        components: {
          'filter-expression': FilterExpression
        },
        computed: {
          shouldRenderApplyButton() {
            // Apply button should only be rendered on Analytics dataset pages
            let url = window.location.hash;
            const oo = self.params.observableOptions();
            return !!(['historical2/infrastructure', 'historical2/user', 'historical2/networks'].some(str => url.includes(str)) || (oo && oo.dataset));
          }
        },
        methods: {
          /**
           *
           * @param {array} filterGroups the array containing all filter groups in the current filter.
           * Each array object contains a "filters" array and an "operator" string.
           */
          handleFiltersUpdated: function(filterGroups) {
            self.filterExpressionGroups = filterGroups;
            self.filterExpressionOperator = filterGroups.operator || self.filterExpressionOperator;
            if (self.vueFilter) { 
              self.vueFilter.filterGroups = self.filterExpressionGroups;
              self.vueFilter.operator = self.filterExpressionOperator;
            }

            self.acceptedTokens(translateFilterExpressionToConditions(self.filterExpressionGroups));
          },
          /**
           * @param {string} operator represents how the filter groups should be combined, either "and" or "or"
           */
          handleOperatorChanged: function(operator) {
            self.filterExpressionOperator = operator;
            self.vueFilter.operator = operator;
            self.acceptedTokens.valueHasMutated();
          }
        },
        vuetify
      });

      let columns = self.columnOptionsObs();
      if (columns && columns.length) {
        self.vueFilter.columns = convertColumns(columns);
      }
    }
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
flexomniqueryWidget.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
    if (self.vueFilter) {
      self.vueFilter.$destroy();
      self.vueFilter.$el.parentNode.removeChild(self.vueFilter.$el);
    }
};

// TODO UI-2501: this probably needs to be updated to handle quick pick filters
function translateFilterExpressionToConditions(filterExpressionGroups) {
  if (filterExpressionGroups && filterExpressionGroups.length) {
    let filtersArray = [];
    filterExpressionGroups.forEach(exp => {
      let op = exp.operator ? exp.operator.toUpperCase() : 'AND';
      if (exp.filters && exp.filters.length) {
        let conditions = [];
        exp.filters.forEach((filter, index) => {
          if (filter.field && filter.filterComplete && (filter.value || filter.valueType === 'noValue')) {
            let lhsTitle = filter.fieldText;
            let isListType = filter.type === 'list' || filter.operatorText === 'in' || filter.operatorText === 'notin';
            let rhsVal = isListType ? '' : filter.queryVar; // todo??
            let listVal = isListType && filter.queryVar ? filter.queryVar.split(',') : [];
            let operatorMap = FILTER_OPERATOR_MAP[filter.type];
            if (!operatorMap) {
              return;
            }
            let filterOp = operatorMap[filter.operatorText || filter.operator || filter.operatorValue];
            if (!filterOp) {
              // TODO: debug code, remove
              console.error('invalid filter operator', filter.operator);
              return;
            }
            let newFilter = {
              id: index + 1, // TODO: is this all we need to do for IDs?
              selectedLhs: filter.field,
              selectedOperator: filterOp,
              rhsText: rhsVal,
              rhsCount: isListType ? listVal.length : '',
              listtype: isListType,
              valueType: isListType ? 'string' : (filter.type === 'number' ) ? 'numeric' : filter.type, // the API expects string type for lists
              selectedRhs: isListType ? listVal : [],
              conjunctionVisible: false, // TODO: is this ever supposed to be true?
              hidden: false, // TODO: is this ever supposed to be true?
              selectedLhsTitle: lhsTitle,
              optitle: filter.operatorText,
              desc: filter.text
            };
            conditions.push(newFilter);
          }
        });
        filtersArray.push({ selectedConjunction: op.toUpperCase(), conditions })
      }
    })
    return filtersArray;
  }
}

function isObservableDataLoaded(observableData) {
    return _.isFunction(observableData);
}

// Converts the columns metadata to a format that the FilterExpression component can use
function convertColumns(originalColumns) {
  let newColumns = [];
  let sortedColumns = _.cloneDeep(originalColumns);
  sortedColumns.sort((a, b) => {
    let titleA = a.title.toLowerCase();
    let titleB = b.title.toLowerCase();
    if (titleA < titleB) return -1;
    if (titleA > titleB) return 1;
    return 0;
  });
  sortedColumns.forEach(col => {
    let type = convertType(col.type);
    if (type !== 'none') {
      let newCol = {
        field: col.name,
        title: col.title,
        filterType: type
      };
      if (col.knownValuePath) {
        newCol.knownValuePath = col.knownValuePath;
      }
      if (col.knownValues) {
        newCol.knownValues = col.knownValues;
      }
      if (col.datasetId) {
        newCol.datasetId = col.datasetId;
      }
      newColumns.push(newCol);
    }
  });
  return newColumns;
}

function getFilterFromCondition(condition, addCpmaMetadata) {
  let value = condition.listtype ? condition.selectedRhs.join(',') : condition.rhsText;
  let shortText = condition.listtype ? condition.selectedRhs.join(', ') : condition.rhsText;
  let type = condition.listtype ? 'list' : convertType(condition.valueType);
  let operatorText = condition.optitle;
  if (!operatorText && condition.selectedOperator) {
    operatorText = REVERSE_FILTER_OPERATOR_MAP[type][condition.selectedOperator];
  }
  let filter = {
    field: condition.selectedLhs,
    fieldText: condition.selectedLhsTitle || condition.lhstitle,
    filterComplete: true,
    operatorValue: condition.selectedOperator,
    text: condition.desc,
    shortText: shortText,
    queryVar: value,
    value,
    type,
    operatorText
  }
  if (filter.field === MODEL_COLUMN || filter.field === SYSTEM_COLUMN) {
    delete filter.fieldText; // force legacy filter format so users cannot edit
  }
  MetadataService.updateCpmaColMetadata(addCpmaMetadata, filter.field, filter);
  return filter;
}

function convertType(type) {
  if (!type) return 'string';
  switch (type) {
    case 'numeric':
    case 'integer':
    case 'currency':
    case 'percentage':
      return 'number';
    case 'datetime':
      return 'none';
    case 'text':
    case 'tag': // TODO: this type applies to the Endpoint Tag column in the settings view. Is converting to "string" here safe?
    case 'string':
      return 'string';
    default:
      return 'none';
  }
};


export default { viewModel: flexomniqueryWidget, template: templateMarkup };
